/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import gql from "graphql-tag";

export const GET_BATCH_DETAIL = gql`
    query GetBatch($batchId: String!) {
        getBatch(batchId: $batchId) {
            _id
            name
            promoVideoUrl
            promoWebsiteUrl
            promoButtonText1
            promoButtonText2
            description
            manufactureDate
            variants
            product {
                name
                images
            }
            shelfLife
            createdAt
            updatedAt
            creatorUser
            isLocked
        }
    }
`;
